import type { DraftPresentation } from '../../contracts/approval-kinds';
import { blocksOfKind, readPresentation } from './tool-call-presentation';

/** The text an edit would leave, attached by the backend to a Work edit approval. */
export interface TextEditPreview {
  before: string;
  after: string;
}

/** The presentation's `text_change` block for the draft's target, or `null`. */
export const readTextEditPreview = (
  context: Record<string, unknown> | undefined,
  toolName: string,
  target: DraftPresentation['target'] | undefined
): TextEditPreview | null => {
  if (!target) return null;
  const change = blocksOfKind(
    readPresentation(context, toolName).blocks,
    'text_change'
  ).find((block) => block.target === target);
  return change ? { before: change.before, after: change.after } : null;
};
